import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const LayoutBackground = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.grey[1]};
  `}
`


export const LayoutContainer = styled.div`
${({ theme }) => `
  ${theme.breakpoints.desktop} {
    display: grid;
    grid-template-columns: 1fr 45%;
  }
`}
`

export const LayoutMainContent = styled.main`
  display: none;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-rows: auto 1fr auto;
      min-height: 100vh;
      padding: 32px 0 32px 0;
      overflow: hidden;
      gap: 32px;
    }
  `}
`

export const BodyContent = styled.div`
    overflow: auto;
`

export const LayoutRightContent = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    ${theme.breakpoints.desktop} {
      min-height: 100vh;
      overflow: hidden;
    }
  `}
`
export const LayoutHeaderContainer = styled.header`
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: grid;
      grid-template-columns: 1fr 45%;
    }
  `}
`

export const LayoutHeaderContent = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.neutrals.w};
    padding: 24px;
    border-bottom: 1px solid ${theme.colors.grey[2]};

    ${theme.breakpoints.desktop} {
      padding: 16px 64px;
      background-color: transparent;
      border-bottom: none;
      margin-bottom: 10px;
    }
  `}
`

export const LayoutHeaderIcon = styled.img`
  height: 33px;
`

export const LayoutHeaderWhiteContent = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.w};
`

export const LayoutFooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 460px;
  margin: auto;
`

const LayoutFooterContent = styled.div`
  display: flex;
  flex-grow: 0;
  align-items: center;

  span {
    ${({ theme }) => css({ ...theme.typographys.base.regular })}
    color: ${({ theme }) => theme.colors.grey[4]};
  }

  svg {
    margin-top: 6px;
  }
`

export const LayoutFooterLeftContent = styled(LayoutFooterContent)`
  span {
    padding-right: 10px;
  }
`
export const LayoutFooterRightContent = styled(LayoutFooterContent)`
  span ~ span {
    padding-left: 24px;
  }
`
